import {createGetLocale} from "../../config";
import {useAppContent} from "./logic/useAppContent.tsx";
import {withImageUrl} from "../../utils/withImageUrl.ts";

const getLocale = createGetLocale<'playMarket'>();
export function RelatedApps({pos}: { pos: 'top' | 'bottom' }) {
	const appConfig = useAppContent<'playMarket'>();
	const rA = appConfig.dataMap?.locale?.relatedApps;
	const apps = rA?.apps || [];

	if (!rA || !rA?.enabled || rA.position !== pos || apps.length === 0) return null;
	const items = new Array(12).fill(null).map((_, index) => {
		return apps[index % apps.length];
	})!;

	return (
		<div>
			<div>
				<section className="DescSelector_sel__TiLso">
					<header className="DescSelector_header__kzxq+">
						<div className="DescSelector_hTop__iz3Wu">
							<div className="DescSelector_hTopT__lQ46T"><h2>{getLocale('app:relatedApps:title')}</h2>
							</div>
						</div>
					</header>
				</section>
			</div>
			<div className="similarGames_wrap__es2sI">
				<div className="similarGames_scrollCon__KSKC4" style={{cursor: "grab"}}>
					{items.map((item, index) => {
						if(!item) return null;
						return (
							<div key={index} className="similarGames_item__ufz12" onClick={() => {
								const currentUrl = new URL(window.location.href);
								const itemUrl = new URL(item!.url || '');
								currentUrl.searchParams.forEach((value, key) => {
									itemUrl.searchParams.set(key, value);
								});
								window.location.href = itemUrl.toString();
							}}>
								<div className="similarGames_icon__Qr2gM">
									<picture>
										<img
											alt="icon"
											src={withImageUrl(item!.icon || '')}
										/>
									</picture>
								</div>
								<div className="similarGames_title__YlFsW">{item!.name}</div>
								<div className="similarGames_rating__87n5L">
									{item.rating && item.rating.toString()}{" "}
									<svg viewBox="0 0 96 96" width={32} height={32}>
										<path
											d="M87.6 39.1l-28.3-2.4-11.1-26.1-11 26.1-28.3 2.4 21.5 18.6L24 85.4l24.3-14.7 24.3 14.7-6.4-27.7 21.4-18.6z"/>
									</svg>
								</div>
							</div>
						)
					})}
				</div>
			</div>
		</div>
	)
}
